import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { signOut } from 'aws-amplify/auth';
import { RegisterService } from '../../../core/_services/register.service';
import { BrandIconUtil } from '../../../utils/brand.util';
import { APP_PROPS } from '../../../cai-common.module';
import { ApplicationProperties } from '../../../core/_base/layout/models/app-properties.model';

@Component({
  selector: 'kt-invalid-token-registration',
  templateUrl: './invalid-token-registration.component.html',
  styleUrls: ['./invalid-token-registration.component.scss'],
  animations: [
    trigger('openClose', [
      // ...
      state(
        'open',
        style({
          maxHeight: '500px',
          opacity: 1,
        }),
      ),
      state(
        'closed',
        style({
          maxHeight: '0',
          overflow: 'hidden',
          opacity: 0,
          marginTop: 0,
          marginBottom: 0,
        }),
      ),
      transition('open => closed', [animate('0.3s')]),
      transition('closed => open', [animate('0.5s 0.3s')]),
    ]),
  ],
  standalone: false,
})
export class InvalidTokenRegistrationComponent implements OnInit {
  isButtonClicked = false;
  isEmailSent: boolean;
  token: string;
  hasError: boolean;

  constructor(
    @Inject(APP_PROPS)
    private readonly appProperties: ApplicationProperties,
    private registerService: RegisterService,
    private route: ActivatedRoute,
    private readonly router: Router,
    private cdr: ChangeDetectorRef,
  ) {}

  async ngOnInit(): Promise<void> {
    await signOut();
    this.token = this.route.snapshot.queryParamMap.get('token');
  }

  async onResendClick(): Promise<void> {
    try {
      const { emailSent } = await this.registerService.resendEmail(this.token);
      this.isEmailSent = emailSent;
    } catch (_) {
      this.hasError = true;
    }
    this.isButtonClicked = true;
    this.cdr.detectChanges();
  }

  onSignUpClick(): void {
    this.router.navigateByUrl(`/register`);
  }

  get backgroundImage(): string {
    return BrandIconUtil.fetchBackgroundIcon(
      this.appProperties.logo,
      '/assets/media/logos/',
    );
  }
}
